import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import API from '../api';
import Layout from './Layout';

function statusLabel(status, t) {
  const map = {
    pending: t('Pending'),
    offered: t('Offered'),
    assigned: t('Assigned'),
    picked_up: t('Picked Up'),
    in_transit: t('In Transit'),
    delivered: t('Delivered'),
    cancelled: t('Cancelled')
  };
  return map[status] || status;
}

export default function OrderTracking() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [order, setOrder] = useState(null);
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      setError('');
      try {
        const [orderRes, historyRes] = await Promise.all([
          API.get(`orders/${id}/`),
          API.get(`orders/${id}/tracking/`)
        ]);
        setOrder(orderRes.data);
        setHistory(Array.isArray(historyRes.data) ? historyRes.data : []);
      } catch (_) {
        setError(t('Failed to load order'));
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      load();
    }
  }, [id, t]);

  if (loading) {
    return (
      <Layout title={t('Order Tracking')}>
        <p>{t('Loading...')}</p>
      </Layout>
    );
  }

  if (error || !order) {
    return (
      <Layout title={t('Order Tracking')}>
        <p className="login-error">{error || t('Order not found')}</p>
        <button className="btn" onClick={() => navigate('/tracking')}>
          {t('Back')}
        </button>
      </Layout>
    );
  }

  return (
    <Layout title={`${t('Order Tracking')} #${order.order_number || order.id}`}>
      <div className="grid two">
        <div className="card">
          <h3 style={{ marginTop: 0 }}>{t('Order Details')}</h3>
          <p><strong>{t('Order Number')}:</strong> {order.order_number}</p>
          <p><strong>{t('Status')}:</strong> {statusLabel(order.status, t)}</p>
          <p><strong>{t('Customer')}:</strong> {order.customer_name}</p>
          <p><strong>{t('Phone')}:</strong> {order.customer_phone}</p>
          <p><strong>{t('Address')}:</strong> {order.delivery_address}</p>
          <p><strong>{t('Driver')}:</strong> {order.driver_name || t('Not assigned')}</p>
        </div>

        <div className="card">
          <h3 style={{ marginTop: 0 }}>{t('Tracking History')}</h3>
          {history.length === 0 ? (
            <p>{t('No tracking history yet')}</p>
          ) : (
            <div className="table-wrap">
              <table className="table">
                <thead>
                  <tr>
                    <th>{t('Status')}</th>
                    <th>{t('Notes')}</th>
                    <th>{t('Date')}</th>
                  </tr>
                </thead>
                <tbody>
                  {history.map((item) => (
                    <tr key={item.id}>
                      <td>{statusLabel(item.status, t)}</td>
                      <td>{item.notes || '-'}</td>
                      <td>{item.created_at ? new Date(item.created_at).toLocaleString() : '-'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
}
